// Load Plugins
var mailcheck        = require('./validate-mailcheck');
var jqueryValidation = require('./validate-validation');

module.exports = function() {
    // Init Validation Modules
    mailcheck();
    jqueryValidation();
};
